import axios from 'axios'

const themes = [
  'default', // Electric Storm (no class needed, uses :root)
  'theme-ocean',
  'theme-sunset',
  'theme-forest',
  'theme-rose',
  'theme-cosmic',
  'theme-cyber',
  'theme-golden',
  'theme-dark',
  'theme-clear',
  'theme-spectrum'
];

const themeNames = {
  'default': 'Electric Storm',
  'theme-ocean': 'Neon Rave',
  'theme-sunset': 'Bass Drop',
  'theme-forest': 'Trance Vision', 
  'theme-rose': 'Rave Heart',
  'theme-cosmic': 'Laser Show',
  'theme-cyber': 'Cyberdelic',
  'theme-golden': 'Golden Beats',
  'theme-dark': 'Dark Mode',
  'theme-clear': 'White Out',
  'theme-spectrum': 'Spectrum'
};

export const getRandomTheme = () => {
  const randomIndex = Math.floor(Math.random() * themes.length);
  return themes[randomIndex];
};

export const applyTheme = async (themeName, saveToServer = false, refreshUserCallback = null) => {
  // Remove all existing theme classes
  themes.forEach(theme => {
    if (theme !== 'default') {
      document.body.classList.remove(theme);
    }
  });
  
  // Apply new theme class (unless it's default)
  if (themeName !== 'default') {
    document.body.classList.add(themeName);
  }
  
  // Store theme preference locally as fallback
  localStorage.setItem('selectedTheme', themeName);
  
  // Save to server if requested and user is authenticated
  if (saveToServer) {
    try {
      await axios.patch('/auth/settings', { theme: themeName });

      if (refreshUserCallback) {
        try {
          await refreshUserCallback();
        } catch (error) {
          console.warn('Failed to refresh user data after theme save:', error);
        }
      }
    } catch (error) {
      console.warn('Error saving theme to server, using localStorage fallback:', error);
    }
  }
  
  return themeName;
};

export const getStoredTheme = () => {
  return localStorage.getItem('selectedTheme') || 'theme-clear';
};

// Get theme from user settings (server)
export const getThemeFromUserSettings = (userSettings) => {
  if (userSettings && userSettings.theme) {
    return userSettings.theme;
  }
  return getStoredTheme(); // Fallback to localStorage
};

export const getThemeName = (themeClass) => {
  return themeNames[themeClass] || 'Electric Storm';
};

export const getAllThemes = () => {
  return themes.map(theme => ({
    class: theme,
    name: themeNames[theme]
  }));
};

export const initializeTheme = async (userSettings = null) => {
  let themeToApply;
  
  if (userSettings && userSettings.theme) {
    // User is authenticated and has theme preference - use server setting
    themeToApply = userSettings.theme;
  } else {
    // Check if we should apply a default theme on fresh load
    const hasVisited = localStorage.getItem('hasVisited');
    
    if (!hasVisited) {
      // First visit - apply White Out theme
      themeToApply = 'theme-clear';
      localStorage.setItem('hasVisited', 'true');
    } else {
      // Return visit - use stored theme
      themeToApply = getStoredTheme();
    }
  }
  
  await applyTheme(themeToApply);
  return themeToApply;
};